import { render, staticRenderFns } from "./OrderAssignmentsList.vue?vue&type=template&id=85a47262&scoped=true&"
import script from "./OrderAssignmentsList.vue?vue&type=script&lang=ts&"
export * from "./OrderAssignmentsList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAssignmentsList.vue?vue&type=style&index=0&id=85a47262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a47262",
  null
  
)

export default component.exports